import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 3.18s-2.125-.398-4-1.193S8 0 8 0 6.375 1.192 4.5 1.987C2.625 2.782.5 3.18.5 3.18l.424 4.19c.41 4.057 3.267 7.272 7.076 8.528 3.765-1.279 6.67-4.503 7.076-8.528l.424-4.19ZM12.957 8a7.73 7.73 0 0 0 .13-.832l.247-2.448a21.25 21.25 0 0 1-2.615-.891A20.43 20.43 0 0 1 8 2.399V8H3.043c.553 2.6 2.415 4.718 4.957 5.767V8h4.957Z",
    fill: "currentColor"
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconSecurity16 = createIcon(IconComponent);